import { NextPage, NextPageContext } from 'next'
import { Featured } from '../../types'
import { mq, colors, breakpoint } from 'plume-ui'
import { css } from '@emotion/react'
import React from 'react'
import { Template } from '@/components/common/Template'
import { fetchFeatured } from '@/lib/featured'
import { FeaturedCard } from '@/components/pages/featured/FeaturedCard'
import { FeaturedHeader } from '@/components/pages/featured/FeaturedHeader'
import Error from '../_error'
import { FeaturedHead } from '@/components/common/Head'

type Props = {
  featured: Featured | null
}

const FeaturedPage: NextPage<Props> = (props) => {
  if (!props.featured) {
    return <Error />
  }

  return (
    <Template>
      <FeaturedHead featured={props.featured}></FeaturedHead>
      <div
        css={css`
          background-color: ${colors.gray40};
          ${mq.large} {
            background-color: ${colors.white00};
          }
        `}
      >
        <FeaturedHeader featured={props.featured}></FeaturedHeader>
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            max-width: ${breakpoint.extraLarge}px;
            padding: 0 0 48px;
            margin: 0px auto;
            ${mq.large} {
              margin-top: -40px;
              padding: 0;
            }
          `}
        >
          {props.featured.articles.map((article, i) => (
            <FeaturedCard
              key={article.id}
              article={article}
              index={i + 1}
              css={css`
                width: 100%;
                ${mq.large} {
                  margin-top: 64px;
                  max-width: 512px;
                  &:nth-of-type(odd) {
                    transform: translateY(-80px);
                  }
                  &:nth-of-type(odd):last-child {
                    margin-bottom: -16px;
                  }
                  &:nth-of-type(even):last-child {
                    margin-bottom: 64px;
                  }
                }
              `}
            />
          ))}
        </div>
      </div>
    </Template>
  )
}

FeaturedPage.getInitialProps = async ({ query }: NextPageContext) => {
  const { slug } = query
  const featured = await fetchFeatured(slug as string)
  return {
    featured,
  }
}

export default FeaturedPage
